import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  CitationService,
  ReferenceTypes,
} from '../../services/citations.service';

@Component({
  selector: 'wk-delete-citations',
  templateUrl: 'wk-delete-citations.html',
  styleUrls: ['./wk-delete-citations.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WKDeleteCitationsComponent {
  toggleDescription: boolean;
  citationRefId: string;
  totalCitedCount: number;
  isMultipleRefsDeletion = false;
  multipleRefsToDelete;
  constructor(
    private readonly wkdialogRef: MatDialogRef<WKDeleteCitationsComponent>,
    private readonly citationService: CitationService
  ) {}

  ngOnInit() {
    this.isMultipleRefsDeletion = this.citationService.isMultipleRefsDeletion;
    if (this.isMultipleRefsDeletion) {
      this.multipleRefsToDelete = [
        ...this.citationService.multipleRefsToDelete,
      ];

      this.multipleRefsToDelete = this.multipleRefsToDelete.filter(
        (item) => item.isDeleteDialogRequired
      );
    }

    this.toggleDescription =
      this.citationService.citationEditType === ReferenceTypes.NumberedRef
        ? true
        : false;
    this.totalCitedCount = this.toggleDescription
      ? this.citationService.totalCitedCount
      : null;
  }

  closeDeleteCitationDialog() {
    this.citationService.isMultipleRefsDeletion = false;
    this.wkdialogRef.close(false);
  }
}
